module.exports = __webpack_public_path__ + "img/ae3d154.svg";